import React, { useState } from "react";
import "./videos.css";

const thumbnail = 'https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/office-thumbnail.webp';

const AcubeIntroVideo = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handlePlayVideo = () => {
        setIsPlaying(true);
        setIsLoading(true); // Start loading when video starts playing
    };

    const handleVideoLoaded = () => {
        setIsLoading(false); // Stop loading once video has started
    };

    return (
        <div className="office-video-container px-3 py-4 acube-video">
            {isPlaying ? (
                <div className="responsive-iframe-container">
                    {isLoading && (
                        <div className="custom-loader-overlay">
                            <div className="custom-spinner"></div>
                        </div>
                    )}
                    <iframe
                        src="https://www.youtube.com/embed/9UNRSrr4bvw?autoplay=1"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={handleVideoLoaded}
                    ></iframe>
                </div>
            ) : (
                <img
                    src={thumbnail}
                    alt="Video Thumbnail"
                    loading="lazy"
                    className="video-thumbnail"
                    onClick={handlePlayVideo}
                />
            )}
        </div>
    );
};

export default AcubeIntroVideo;
